module.exports = __webpack_public_path__ + "static/img/bg-function-5.02c632bb.png";